module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_6000.a6b788ab.png";